import { Box } from '@material-ui/core';
import { WarningAlertWithIcon } from '../../../../../shared/components/alerts/WarningAlertWithIcon';
import React from 'react';

export function SkWarning() {
    return (
        <WarningAlertWithIcon>
            <Box>
                This candidate has been previously employed or contracted by
                Noor Group. Before proceeding with an offer,
                please contact steveandkatesupport@noorstaffinggroup.com
                for a review of prior employment status and eligibility for rehire.
            </Box>
        </WarningAlertWithIcon>
    );
}
